import { observable } from "mobx";

import { ImageService } from "../../services/image/ImageService";
import { DictionaryDefinition } from "../dictionary/DictionaryDefinition";
import { NullDictionaryDefinition } from "../dictionary/NullDictionaryDefinition";

export class Word {
  constructor(readonly word: string) {
    this.definition = new NullDictionaryDefinition(word);
  }

  originalWord: string;
  originalLanguage: string;
  dictionaryUrl: string;
  // [not in use] The 'fallback' image from GoogleSheets, (a *slow* and not so accurate public service)
  imageUrl: string;
  // The imageUrl that is actually used - defaults to a blank image.
  @observable
  activeImageUrl: string = ImageService.BLANK_IMAGE_URL;
  hasLocalImage: boolean = false;
  city: string;
  country: string;
  wordType: string;
  @observable
  definition: DictionaryDefinition;
  hasDefinition() {
    return this.definition.isPopulated;
  }
  notes: string | null;
}



// WEBPACK FOOTER //
// ./stores/word/Word.ts